import * as React from "react"
import { BlockRenderer } from "../../components/block_renderer"
import { Jumbo, renderContents } from "../../components/jumbo"
import { BlogPostProps } from './blogPostState'

export const BlogPost = (props: BlogPostProps) => {
  const { headerTitle, description, phImageUrl, phImageUrlLarge, imageAlt, blocks, categories, dateUpdated } = props

  return (
    <>
      <Jumbo
        title={headerTitle}
        contents={dateUpdated.format("dddd D MMMM YYYY")}
        imageUrl={phImageUrl}
        imageUrlLarge={phImageUrlLarge}
        imageAlt={imageAlt}
        size="small"
      />

      <div className="intro">
        <div className="intro__inner container--sg align--center">
          {categories && categories.size > 0 &&
            <div className="intro__tags tags">
              <ul className="tags__list">
                {categories.map(c => <li className="tags__item">
                  <span className="tags__tag">{c.name}</span>
                </li>)}
              </ul>
            </div>
          }

          {description.toString().length > 0 && (
            <div className="intro__text text--m text--styled">
              {renderContents(
                description,
                <div />,
                <div />
              )}
            </div>
          )}
        </div>
      </div>
      
      <BlockRenderer blocks={blocks} />
    </>
  )
}
